import GrossDemandDeterminationTable from "../component/GrossDemandDeterminationTable";
import { Route,Routes} from 'react-router-dom';
import { Navigate } from 'react-router';
import GrossCarSegmentDDTable from "../component/GrossCarSegmentDDTable";
import FleetPlanningTitleNavigation from "../component/FleetPlanningTitleNavigation";
import FleetPlanningMainTitle from "../component/FleetPlanningMainTitle";
import { CarSegmentSupplyDetermination } from "../component/CarSegmentSupplyDetermination";
import { GenericTitleHeader } from "../component/common/GenericTitleHeader";
import * as Mui from "@mui/system";
import GenericFilterBox from "../component/common/GenericFilterBox";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import SectionHeader from "../../../util/component/SectionHeader";
import { useHasScope } from "../../../config/globalConfig";


const FleetPlanning = () => {
  const hasScope = useHasScope;
  const [dataSearchFormOne, setDataSearchFormOne] = useState<any>(null)
  const [dataSearchFormTwo, setDataSearchFormTwo] = useState<any>(null)
  const [dataSearchFormThree, setDataSearchFormThree] = useState<any>(null)
  const [refreshButton, setRefreshButton] = useState<boolean>(false);
  const { t } = useTranslation(["operation"]);
    return (
      <>
      
        <Mui.Box >
            <SectionHeader
                title={t("fleetPlanning.titleFirst") + " " + t("fleetPlanning.titleSecond")}
            />

              <FleetPlanningTitleNavigation 
              
              setDataSearchFormOne={setDataSearchFormOne}
              setDataSearchFormTwo={setDataSearchFormTwo}
              setDataSearchFormThree={setDataSearchFormThree}
              refreshButton={refreshButton}
              setRefreshButton={setRefreshButton}

              />
           
            
            <Routes >

            <Route path="/" element={
                 hasScope("SCOPE_MANAGE_GDD_PLANNING") ?   
                  <Navigate to="/operation/planning/gross"/> :
                  (hasScope("SCOPE_MANAGE_CSD_PLANNING") ? 
                  <Navigate to="/operation/planning/carsegment"/> :
                  (hasScope("SCOPE_MANAGE_CSS_PLANNING") ? 
                  <Navigate to="/operation/planning/carsupply"/> :
                  <Navigate to="/operation/planning/gross"/>))          
            }/>

            <Route path="/gross"   element={
            <GrossDemandDeterminationTable
            
            dataSearchFormOne={dataSearchFormOne}
            refreshButton={refreshButton}
            setRefreshButton={setRefreshButton}
            />}/>
            <Route path="/carsegment"  element={
            <GrossCarSegmentDDTable
            refreshButton={refreshButton}
            setRefreshButton={setRefreshButton}
            dataSearchFormTwo={dataSearchFormTwo}
            />}/>
            <Route
              path="/carsupply"
              element={
              <CarSegmentSupplyDetermination
              refreshButton={refreshButton}
              setRefreshButton={setRefreshButton}
              dataSearchFormThree={dataSearchFormThree}
                 />}
            />
          </Routes>
           
            
        </Mui.Box>
        </>
  );
};

export default FleetPlanning;
